export default __webpack_public_path__ + "static/media/Beehaz_07_work_anywhere.d2cd008f.png";